import React, { Component } from "react";
import { connect } from "react-redux";

class RegionWrap extends Component {
  render() {
    const { region, myBagData } = this.props;
    let regionList = region;

    if (myBagData.hasMotherOfPearls) {
      regionList = regionList.filter(item => item.code !== "US");
    }

    return (
      <>
        {regionList.map((data, i) => (
          <option key={i} value={data.code}>
            {data.name}
          </option>
        ))}
      </>
    );
  }
}

const mapStateToProps = state => ({
  region: state.countryList.region,
  myBagData: state.myBag.myBagData
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RegionWrap);
